import React from 'react';
import {FormattedMessage} from 'react-intl';
import InputDateText from './InputDateText';

const labelSubTextSpanStyle = {
    fontStyle: 'italic',
    fontWeight: 'normal'
};

class InputDate extends React.Component {

    render() {
        return (
            <div className="field">
                <label htmlFor={this.props.id}>{this.props.fieldLabel}</label>
                {
                    this.props.fieldLabelSubText &&
                    <span style={labelSubTextSpanStyle}>{this.props.fieldLabelSubText}</span>
                }
                <div className="element">
                    <div className="date-field">
                        <div className="date-field-month">
                            <InputDateText
                                id={this.props.monthId}
                                name={this.props.monthName}
                                fieldLabel=""
                                fieldLabelSubText="MM"
                                type="tel"
                                value={this.props.monthValue}
                                fieldError={this.props.fieldError}
                                handleChange={(e) => this.props.handleChange(e)}
                                keyUpChange={(e) => this.props.handleChange(e)}
                                maxlength="2"
                                size="3"
                                placeholder="MM"
                                pattern="\d*"
                            />
                        </div>
                        <div className="date-field-day">
                            <InputDateText
                                id={this.props.dayId}
                                name={this.props.dayName}
                                fieldLabel=""
                                fieldLabelSubText="DD"
                                type="tel"
                                value={this.props.dayValue}
                                fieldError={this.props.fieldError}
                                handleChange={(e) => this.props.handleChange(e)}
                                keyUpChange={(e) => this.props.handleChange(e)}
                                maxlength="2"
                                size="3"
                                placeholder="DD"
                                pattern="\d*"
                            />
                        </div>

                        <div className="date-field-year">
                            <InputDateText
                                id={this.props.yearId}
                                name={this.props.yearName}
                                fieldLabel=""
                                fieldLabelSubText="YY"
                                type="tel"
                                value={this.props.yearValue}
                                fieldError={this.props.fieldError}
                                handleChange={(e) => this.props.handleChange(e)}
                                keyUpChange={(e) => this.props.handleChange(e)}
                                maxlength="2"
                                size="3"
                                placeholder="YY"
                                pattern="\d*"
                            />
                        </div>
                        {(this.props.fieldError && this.props.fieldErrorMessage) &&
                        <p id="name-error" className="error"><FormattedMessage id={this.props.fieldErrorMessage}/></p>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default InputDate;
